module.exports = __webpack_public_path__ + "static/media/Perseus.49e82d34.jpg";